import { useQuery, useTeam } from '@vrplatform/data';
import { day, utc } from '@vrplatform/utils';
import { Anchor, Skeleton, Text } from '@mantine/core';
import { Link } from 'react-router-dom';

export const DrawerInfoCardOwnerStatementsLinks = ({
  ids,
}: {
  ids: string[];
}) => {
  const [{ id: teamId }] = useTeam();

  const { data, isLoading } = useQuery(
    (q, args) => {
      if (!args.ids.length || !args.teamId)
        return {
          ownerStatements: [],
        };

      return {
        ownerStatements: q
          .ownerStatements({
            where: { id: { _in: args.ids }, tenantId: { _eq: args.teamId } },
          })
          .map((statement) => ({
            id: statement.id,
            listingPeriodId: statement.listingOwnershipPeriodId!,
            currency: statement.currency,
            startAt: utc(statement.startAt).yyyymmdd(),
          })),
      };
    },
    {
      skip: !ids.length || !teamId,
      variables: {
        ids,
        teamId,
      },
      queryKey: ['expenses', 'ownerStatements'],
      keepPreviousData: true,
    }
  );

  if (!ids.length) return null;

  if (isLoading) return <Skeleton h={10} />;

  if (!data) return null;

  return (
    <Text>
      {data.ownerStatements.map((x, index, arr) => (
        <>
          <Anchor
            component={Link}
            to={`/statement/${x.listingPeriodId}?date=${x.startAt}&currency=${x.currency}`}
            key={x.id}
          >
            {day(x.startAt).format('MMM YYYY')}
          </Anchor>
          {index !== arr.length - 1 && ', '}
        </>
      ))}
    </Text>
  );
};
